export default {"src":"/_next/static/media/HeadSpinalCordInjuries.f49cba63.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};